
import { ModuleWithProviders, NgModule, APP_INITIALIZER } from '@angular/core';
import { GTM_ID, GtmLoaderService } from './_services/gtm_loader.service';

export interface GtmConfig { id: string; autoload?: boolean }

@NgModule({})
export class GtmModule {
    static forRoot(config: GtmConfig): ModuleWithProviders<GtmModule> {
        return {
            ngModule: GtmModule,
            providers: [
                { provide: GTM_ID, useValue: config.id },
                ...(config.autoload === false ? [] : [{
                    provide: APP_INITIALIZER,
                    multi: true,
                    useFactory: (loader: GtmLoaderService) => () => loader.start(),
                    deps: [GtmLoaderService]
                }]),
            ],
        };
    }
}

